var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0835 72.9165L72.9168 52.0832M41.0332 25.6396L37.0721 24.8802C29.8418 23.4941 23.4943 29.8416 24.8804 37.0719L25.6399 41.033C26.4232 45.1192 24.6999 49.2796 21.2566 51.6151L17.9187 53.8791C11.8259 58.0115 11.8259 66.9882 17.9187 71.1207L21.2566 73.3847C24.6999 75.7201 26.4232 79.8806 25.6399 83.9667L24.8804 87.9279C23.4943 95.1582 29.8418 101.506 37.0721 100.12L41.0332 99.3601C45.1194 98.5768 49.2799 100.3 51.6153 103.743L53.8793 107.081C58.0118 113.174 66.9885 113.174 71.1209 107.081L73.3849 103.743C75.7203 100.3 79.8808 98.5768 83.967 99.3601L87.9281 100.12C95.1584 101.506 101.506 95.1582 100.12 87.9279L99.3604 83.9667C98.577 79.8805 100.3 75.7201 103.744 73.3846L107.082 71.1207C113.174 66.9882 113.174 58.0115 107.082 53.8791L103.744 51.6151C100.3 49.2796 98.577 45.1192 99.3604 41.033L100.12 37.0719C101.506 29.8416 95.1584 23.4941 87.9281 24.8802L83.967 25.6396C79.8808 26.423 75.7203 24.6997 73.3849 21.2564L71.1209 17.9184C66.9885 11.8257 58.0118 11.8257 53.8793 17.9184L51.6153 21.2564C49.2799 24.6997 45.1194 26.423 41.0332 25.6396Z",
    stroke: "#EF233C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5207 80.8334C72.5867 80.8334 70.2082 78.4549 70.2082 75.5209C70.2082 72.5869 72.5867 70.2084 75.5207 70.2084C78.4547 70.2084 80.8332 72.5869 80.8332 75.5209C80.8332 78.4549 78.4547 80.8334 75.5207 80.8334ZM49.479 54.7917C46.545 54.7917 44.1665 52.4133 44.1665 49.4792C44.1665 46.5452 46.545 44.1667 49.479 44.1667C52.413 44.1667 54.7915 46.5452 54.7915 49.4792C54.7915 52.4133 52.413 54.7917 49.479 54.7917Z",
    stroke: "#EF233C",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.c0ec8d0b31bf02884ece6eda5fbcaa54.svg";
export { ForwardRef as ReactComponent };